import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testemonial.component.html',
  styleUrl: './testemonial.component.scss'
})
export class TestemonialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  getStars(rating: number): string[] {
    return Array.from({ length: 5 }, (_, i) => (i < rating ? 'yellow' : ''));
  }

  testimonial = [
    {
      img: 'assets/images/event/testimonial/headshot_circular_2.png',
      msgIcon: 'assets/images/event/testimonial/message.png',
      name: 'Leonie Berger',
      designation: 'Marketing Manager',
      testimonial: 'Die fertigen E-Mail-Listen haben mir geholfen, meine Zielgruppe schnell und gezielt zu erreichen. Sehr empfehlenswert für jeden, der im Marketing tätig ist.',
      rating: 5,
    },
    {
      img: 'assets/images/event/testimonial/headshot_circular_1.png',
      msgIcon: 'assets/images/event/testimonial/message.png',
      name: 'Carlos Navarro',
      designation: 'Social Media Manager',
      testimonial: 'Die Listen sind gut, aber der Preis könnte etwas günstiger sein. Ansonsten sehr praktisch für schnelle Kampagnen.',
      rating: 4,
    },
    {
      img: 'assets/images/event/testimonial/headshot_circular_3.png',
      msgIcon: 'assets/images/event/testimonial/message.png',
      name: 'Thomas Horváth',
      designation: 'Unternehmerin',
      testimonial: 'Ich habe die Liste für meine letzte Marketingaktion verwendet und konnte sofort die richtigen Kontakte ansprechen. Die Datenqualität ist hervorragend.',
      rating: 5,
    },
    {
      img: 'assets/images/event/testimonial/headshot_circular_4.png',
      msgIcon: 'assets/images/event/testimonial/message.png',
      name: 'Lina Chen',
      designation: 'Vertriebsleiter',
      testimonial: 'Die E-Mail-Liste ist gut strukturiert, aber ich hätte mir eine genauere Segmentierung gewünscht. Insgesamt aber ein nützliches Tool.',
      rating: 4,
    },
    {
      img: 'assets/images/event/testimonial/headshot_circular_5.png',
      msgIcon: 'assets/images/event/testimonial/message.png',
      name: 'David Okafor',
      designation: 'E-Commerce-Manager',
      testimonial: 'Sehr hilfreich, um schnell eine Zielgruppe anzusprechen. Einfach zu verwenden und liefert gute Ergebnisse für mein Geschäft.',
      rating: 5,
    }
  ];

  testimonialcarouselOptions= {
    items: 1,
    margin: 0,
    autoHeight: true,
    nav: true,
    dots: false,
    navText: ['<img src="assets/images/Own/left.png">', '<img src="assets/images/Own/right.png">'],
    autoplay: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true
  }
}
